import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import API_URL from './api/config';
import 'react-toastify/dist/ReactToastify.css';

function RegisterConfirmVerify() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const emailFromUrl = searchParams.get('email');
  const codeFromUrl = searchParams.get('code');

  const [status, setStatus] = useState('loading'); 
  const [message, setMessage] = useState('');

  useEffect(() => {
    const verify = async () => {
      if (!emailFromUrl || !codeFromUrl) {
        setStatus('error');
        setMessage('Invalid verification link.');
        return;
      }

      try {
        setStatus('loading');
        setMessage('Verifying your account...');

        const res = await axios.post(`${API_URL}/register-confirm-verify-email-api`, {
          email: emailFromUrl,
          verificationCode: codeFromUrl
        });


        if (res.data.Status === "Success") {
            setStatus('success');
            setMessage('Email verified successfully!');
          
            localStorage.removeItem('pendingVerificationEmail');
          
            //toast.success('Account verified!', { position: "top-right", autoClose: 2000 });
           
          } else {
            setStatus('error');
            setMessage(res.data.Message || 'Verification failed.');
            //toast.error(res.data.Message || 'Verification failed');
          }
 

      } catch (err) {
        setStatus('error');
        setMessage('Verification failed. Please try again later.');
        //toast.error('Verification error');
      }
    };

    verify();
  }, [emailFromUrl, codeFromUrl, navigate]);


  
  const [loading, setLoading] = useState(false);
  
  const handleResendVerification = async () => {
    if (!emailFromUrl) {
      toast.error('No email address found. Please register again.');
      return;
    }
  
    try {
      setLoading(true);
  
      const response = await axios.post(
        `${API_URL}/register-confirm-verify-email-resend-api`,
        {
          email: emailFromUrl
        }
      );
  
      if (response.data.Status === "Success") {
        setMessage('New verification code sent! Please check your email.');
      } else {
        toast.error(response.data.Message || 'Failed to resend code');
      }
    } catch (error) {
      toast.error('Failed to resend verification code');
    } finally {
      setLoading(false);
    }
  };




  return (
    
    <div
  className="min-vh-100 d-flex align-items-center justify-content-center"
  style={{ 
    background: 'linear-gradient(135deg, #f4f7f5 0%, #e8f0ea 100%)',
    fontFamily: "'DM Sans', sans-serif",
    padding: '1rem',
    overflowY: 'auto',  /* Allow scrolling if needed */
    minHeight: '100vh'
  }}
>
  <ToastContainer />

  {/* Main Card Container */}
  <div style={{
    maxWidth: '520px',
    width: '90%',
    background: '#fff',
    borderRadius: '28px',
    overflow: 'visible',  /* Changed from 'hidden' to 'visible' */
    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
    transform: 'translateY(0)',
    transition: 'transform 0.3s ease',
    animation: 'fadeInUp 0.5s ease-out',
    margin: 'auto'  /* Center the card */
  }}>
    
    {/* Header Section with Gradient */}
    <div style={{
      background: 'linear-gradient(135deg, #0d6e28 0%, #0a5520 100%)',
      padding: '2rem 1.5rem 1.5rem',  /* Reduced padding */
      textAlign: 'center',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Decorative background circles - made smaller */}
      <div style={{
        position: 'absolute',
        top: '-30%',
        right: '-20%',
        width: '150px',
        height: '150px',
        borderRadius: '50%',
        background: 'rgba(255,255,255,0.05)',
        pointerEvents: 'none'
      }}></div>
      <div style={{
        position: 'absolute',
        bottom: '-30%',
        left: '-20%',
        width: '150px',
        height: '150px',
        borderRadius: '50%',
        background: 'rgba(255,255,255,0.05)',
        pointerEvents: 'none'
      }}></div>
      
      {/* Logo */}
      <div style={{ 
        marginBottom: '1rem',  /* Reduced margin */
        position: 'relative',
        zIndex: 1
      }}>
        <img 
          src="img/logo_1.png" 
          alt="Oret Africa" 
          height="50"  /* Slightly smaller */
          style={{ 
            filter: 'brightness(0) invert(1)',
            transition: 'transform 0.3s ease'
          }} 
        />
      </div>
      
      {/* Status Icon */}
      <div style={{ marginBottom: '0.75rem', position: 'relative', zIndex: 1 }}>
        {status === 'loading' && (
          <div style={{
            width: '60px',
            height: '60px',
            margin: '0 auto',
            background: 'rgba(255,255,255,0.15)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backdropFilter: 'blur(10px)',
            animation: 'pulse 2s infinite'
          }}>
            <div className="spinner-border text-white" role="status" style={{ width: '30px', height: '30px' }}>
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}
        
        {status === 'success' && (
          <div style={{
            width: '60px',
            height: '60px',
            margin: '0 auto',
            background: 'rgba(255,255,255,0.15)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '35px',
            backdropFilter: 'blur(10px)',
            animation: 'scaleIn 0.5s ease-out'
          }}>
            ✓
          </div>
        )}
        
        {status === 'error' && (
          <div style={{
            width: '60px',
            height: '60px',
            margin: '0 auto',
            background: 'rgba(255,255,255,0.15)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '35px',
            backdropFilter: 'blur(10px)',
            animation: 'shake 0.5s ease-out'
          }}>
            ✗
          </div>
        )}
      </div>
      
      {/* Title */}
      <h2 style={{
        color: 'white',
        fontSize: '1.5rem',  /* Reduced font size */
        fontWeight: '600',
        marginBottom: '0.25rem',
        fontFamily: "'Playfair Display', serif",
        position: 'relative',
        zIndex: 1,
        animation: 'fadeIn 0.5s ease-out'
      }}>
        {status === 'loading' && 'Email Verification'}
        {status === 'success' && 'Verification Complete!'}
        {status === 'error' && 'Verification Failed'}
      </h2>
      
      {/* Subtitle */}
      <p style={{
        color: 'rgba(255,255,255,0.9)',
        fontSize: '0.8rem',  /* Reduced font size */
        marginBottom: 0,
        position: 'relative',
        zIndex: 1
      }}>
        {status === 'loading' && 'Please wait while we verify your account'}
        {status === 'success' && 'Your account has been successfully verified'}
        {status === 'error' && 'We could not verify your email address'}
      </p>
    </div>

    {/* Body Content */}
    <div style={{ 
      padding: '1.5rem',  /* Reduced padding */
      maxHeight: '60vh',  /* Limit height */
      overflowY: 'auto',  /* Make content scrollable if needed */
    }}>
      
      {/* Message Display */}
      <div style={{
        textAlign: 'center',
        marginBottom: '1rem'
      }}>
        {status === 'loading' && (
          <div>
            <p style={{
              color: '#4a5568',
              fontSize: '0.9rem',
              lineHeight: '1.5',
              marginBottom: '0.5rem'
            }}>
              {message}
            </p>
            <div style={{
              marginTop: '0.75rem',
              padding: '0.5rem',
              borderRadius: '8px',
              background: '#f8fcf9',
              display: 'inline-block'
            }}>
              <p style={{
                color: '#0d6e28',
                fontSize: '0.7rem',
                marginBottom: 0,
                display: 'flex',
                alignItems: 'center',
                gap: '6px'
              }}>
                <span>🔐</span> Secure verification in progress
              </p>
            </div>
          </div>
        )}


{status === 'success' && (
              <div>
                <div
                  style={{
                    background: 'linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%)',
                    border: 'none',
                    borderRadius: '12px',
                    padding: '0.875rem',
                    marginBottom: '0.875rem',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                  }}
                >
                  <p
                    style={{
                      color: '#155724',
                      fontSize: '0.9rem',
                      marginBottom: 0,
                      fontWeight: 500,
                    }}
                  >
                    {message}
                  </p>
                </div>
 
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    marginTop: '0.75rem',
                    marginBottom: '1.25rem',
                  }}
                >
                  <p style={{ color: '#666', fontSize: '0.8rem', marginBottom: 0, textAlign: 'center' }}>
                    Your email is confirmed. Go back to the app to complete registration — you'll be
                    signed in automatically.
                  </p>
                </div>
 
                {/* Divider */}
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    margin: '1rem 0',
                  }}
                >
                  <div style={{ flex: 1, height: '1px', background: '#e5ede8' }}></div>
                  <span style={{ fontSize: '0.7rem', color: '#999', fontWeight: 600 }}>OR</span>
                  <div style={{ flex: 1, height: '1px', background: '#e5ede8' }}></div>
                </div>
 
                <p
                  style={{
                    textAlign: 'center',
                    color: '#666',
                    fontSize: '0.8rem',
                    marginBottom: '0.75rem',
                  }}
                >
                  Login to continue on browser
                </p>
 
                <Link
                  to="/"
                  style={{
                    display: 'block',
                    textAlign: 'center',
                    width: '100%',
                    padding: '0.7rem',
                     
                    border: 'none',
                    borderRadius: '40px',
                    fontWeight: 600,
                    fontSize: '0.85rem',
                    color: '#ffffff',
                    textDecoration: 'none',
                    transition: 'all 0.2s ease',
                  }}
                   className='btn btn-primary'
                >
                  <i className="fas fa-sign-in-alt me-2"></i>
                  Login
                </Link>
              </div>
            )}


        {/*{status === 'success' && (
          <div>
            <div style={{
              background: 'linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%)',
              border: 'none',
              borderRadius: '12px',
              padding: '0.875rem',
              marginBottom: '0.875rem',
              boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
            }}>
              <p style={{
                color: '#155724',
                fontSize: '0.9rem',
                marginBottom: 0,
                fontWeight: '500'
              }}>
                {message}
              </p>
            </div>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              marginTop: '0.75rem'
            }}>
               
              <p style={{
                color: '#666',
                fontSize: '0.8rem',
                marginBottom: 0
              }}>
                Your email is confirmed. Go back to the app to complete registration — you'll be signed in automatically.
                 
              </p>
            </div>

            OR 
            Login to continue on browser
            <Link to="/">Login</Link>
          </div>
        )}*/}

        {status === 'error' && (
          <div>
            <div style={{
              background: 'linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%)',
              border: 'none',
              borderRadius: '12px',
              padding: '0.875rem',
              marginBottom: '0.875rem',
              boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
            }}>
              <p style={{
                color: '#721c24',
                fontSize: '0.9rem',
                marginBottom: 0,
                fontWeight: '500'
              }}>
                {message}
              </p>
            </div>
            
            {/* Email Display */}
            {emailFromUrl && (
              <div style={{
                background: '#f8fcf9',
                borderRadius: '12px',
                padding: '0.75rem',
                marginBottom: '0.875rem',
                border: '1px solid #e5ede8',
                transition: 'all 0.2s ease'
              }}>
                <p style={{
                  color: '#666',
                  fontSize: '0.65rem',
                  marginBottom: '0.25rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px'
                }}>
                  Attempted to verify
                </p>
                <p style={{
                  color: '#0d6e28',
                  fontSize: '0.75rem',
                  fontWeight: '600',
                  marginBottom: 0,
                  wordBreak: 'break-all'
                }}>
                  {emailFromUrl}
                </p>
              </div>
            )}
            
            {/* Troubleshooting Tips */}
            <div style={{
              marginTop: '0.5rem',
              padding: '0.5rem',
              background: '#fafafa',
              borderRadius: '8px'
            }}>
              <p style={{
                fontSize: '0.65rem',
                color: '#888',
                marginBottom: 0
              }}>
                💡 Tip: Check if the link has expired or request a new verification email
              </p>
            </div>
          </div>
        )}
      </div>

      {/* Action Buttons */}
      <div style={{ textAlign: 'center' }}>
        {status === 'error' && (
          <>
            <button
  onClick={handleResendVerification}
  disabled={loading}
  style={{
    width: '100%',
    padding: '0.75rem',
    backgroundColor: loading ? '#6c757d' : '#0d6e28',
    color: 'white',
    border: 'none',
    borderRadius: '12px',
    fontSize: '0.9rem',
    fontWeight: '600',
    cursor: loading ? 'not-allowed' : 'pointer',
    opacity: loading ? 0.8 : 1,
    marginBottom: '1rem',
    transition: 'all 0.2s ease'
  }}
  onMouseEnter={(e) => {
    if (!loading) {
      e.target.style.backgroundColor = '#0a5520';
    }
  }}
  onMouseLeave={(e) => {
    if (!loading) {
      e.target.style.backgroundColor = '#0d6e28';
    }
  }}
>
  {loading ? (
    <>
      <span
        className="spinner-border spinner-border-sm me-2"
        role="status"
        style={{
          width: '0.8rem',
          height: '0.8rem'
        }}
      ></span>
      Sending...
    </>
  ) : (
    <>
      <i className="fas fa-paper-plane me-2"></i>
      Resend Verification Email
    </>
  )}
</button>
          </>
        )}

        {/* Help Text */}
        <p style={{
          fontSize: '0.7rem',
          color: '#999',
          marginTop: '1rem',
          marginBottom: 0
        }}>
          Need help? <a href="mailto:info@oret.africa" style={{ color: '#0d6e28', textDecoration: 'none' }}>Contact Support</a>
        </p>
      </div>
    </div>

    {/* Footer */}
    <div style={{
      padding: '0.75rem 1.5rem',  /* Reduced padding */
      backgroundColor: '#f8fcf9',
      borderTop: '1px solid #e5ede8',
      textAlign: 'center'
    }}>
      <p style={{
        fontSize: '0.65rem',
        color: '#999',
        marginBottom: 0
      }}>
        © 2026 Oret Africa — All rights reserved
      </p>
    </div>
  </div>
</div>
  );
}

export default RegisterConfirmVerify;